import React, { useCallback, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import Search from '../../components/Search'
import PlaceBar from '../../components/PlaceBar'
import MediaGrid from '../../components/MediaGrid/MediaGrid.js'

import './UnsplashLibrary.scss'

import {
    ASSET_MANAGER__LIBRARY__DEL_IF_EQUALS_SELECTED_IMAGE_ID,
    ASSET_MANAGER__LIBRARY__SET_SELECTED_IMAGE_ID,
    ASSET_MANAGER__UNSPLASH_LIBRARY__INIT,
    ASSET_MANAGER__UNSPLASH_LIBRARY__SAVE_IMAGE,
    ASSET_MANAGER__UNSPLASH_LIBRARY__SEARCH,
    ASSET_MANAGER__UNSPLASH_LIBRARY__UP_IMAGES_PAGE,
} from '../../../../store/actions/asset_manager'

const UnsplashLibrary = ({ onPlaceImage, t }) => {
    const dispatch = useDispatch()
    const { images, selectedImageId, isLoadImages, isLoadError } = useSelector(state => state.assetManager.library)

    useEffect(() => {
        dispatch(ASSET_MANAGER__UNSPLASH_LIBRARY__INIT())
    }, [])

    const placeImage = useCallback(async () => {
        dispatch(ASSET_MANAGER__UNSPLASH_LIBRARY__SAVE_IMAGE())

        const [{ previewUrl = '', authorInfo, id } = {}] = images.content.filter(
            item => item.originalImageId === selectedImageId,
        )

        onPlaceImage({ src: previewUrl, id, author: authorInfo }, true)
    }, [onPlaceImage, images, selectedImageId])

    return (
        <div className="unsplash-library">
            <div className="unsplash-library__header">
                <h1 className="unsplash-library__header_title">{t('Unsplash library')}</h1>
                <p className="unsplash-library__header_description">
                    {t('Start with freely usable images from Unsplash library. Read more about the')}&nbsp;
                    <a className="unsplash-library__link" href="https://unsplash.com/license" target="_blank">
                        {t('Unsplash License')}
                    </a>
                </p>
            </div>
            <Search onSearchValueChange={value => dispatch(ASSET_MANAGER__UNSPLASH_LIBRARY__SEARCH(value))} />
            <MediaGrid
                data={images.content}
                selectedId={selectedImageId}
                isLoadData={isLoadImages}
                isCanLoadData={!images.last && !isLoadError}
                onUpPage={() => dispatch(ASSET_MANAGER__UNSPLASH_LIBRARY__UP_IMAGES_PAGE())}
                onSelectImage={id => dispatch(ASSET_MANAGER__LIBRARY__SET_SELECTED_IMAGE_ID(id))}
                onUnselectImage={id => dispatch(ASSET_MANAGER__LIBRARY__DEL_IF_EQUALS_SELECTED_IMAGE_ID(id))}
            />
            {selectedImageId ? (
                <PlaceBar onClick={placeImage} t={t}>
                    <div className="unsplash-library__place_bar_description">
                        <p>{t('This image is provided by Unsplash.')}</p>
                        <p>
                            {t('By using it, you agree to comply with')}&nbsp;
                            <a className="unsplash-library__link" href="https://unsplash.com/terms" target="_blank">
                                {t("Unsplash's Terms. Learn more")}
                            </a>
                        </p>
                    </div>
                </PlaceBar>
            ) : null}
        </div>
    )
}

export default withTranslation('translations')(UnsplashLibrary)
